import { PlusCircle } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { AssetCategoryList } from 'components/assetCategories/AssetCategoryList';
import { useAssetCategories, useUpdateAssetCategory } from 'hooks/useAssets';
import { AssetCategory } from 'shared/types/asset';
import { toast } from 'react-toastify';
import { Button } from '@/components/ui/button';
import * as Sentry from '@sentry/react';

const AssetCategoriesContent = () => {
  const navigate = useNavigate();
  const { categories, isLoading, refetch } = useAssetCategories();
  const { updateCategory } = useUpdateAssetCategory();

  const handleEdit = (category: AssetCategory) => {
    navigate(`/settings/voorzieningen-categorieen/${category.id}`, { state: { returnTo: '/assets' } });
  };

  const handleDeactivate = async (category: AssetCategory) => {
    try {
      await updateCategory(category.id.toString() as unknown as string, {
        active: !category.active,
      });
      toast.success(
        category.active
          ? `Categorie "${category.name}" gedeactiveerd`
          : `Categorie "${category.name}" geactiveerd`
      );
      refetch();
    } catch (error) {
      Sentry.captureException(error, {
        tags: { feature: 'asset-categories' },
        extra: { categoryId: category.id, action: category.active ? 'deactivate' : 'activate' },
      });
      toast.error('Fout bij (de)activeren van categorie');
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Beheer categorieën, types en velden voor voorzieningen
        </p>
        <Button onClick={() => navigate('/settings/voorzieningen-categorieen/nieuw', { state: { returnTo: '/assets' } })}>
          <PlusCircle className="h-4 w-4 mr-2" />
          Nieuwe Categorie
        </Button>
      </div>

      <AssetCategoryList
        categories={categories}
        onEdit={handleEdit}
        onDeactivate={handleDeactivate}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AssetCategoriesContent;
